import React, { FC } from 'react';

import { useParams } from 'react-router-dom';

import AchievementsForm from 'components/statements/AchievementsForm';
import FillingStatementsForm from 'components/statements/FillingStatementsForm';
import useFillingStatementsRoutesContext from 'hooks/statements/useFillingStatementsRoutesContext';
import { selectIsUserAdmin } from 'redux/selectors';

import Button from '../../../components/common/ui-kit/Button';
import Input from '../../../components/common/ui-kit/Input';
import useAppSelector from '../../../hooks/common/useAppSelector';
import { useAchievementsPageForm } from '../../../hooks/statements/achievements/useAchievementsPageForm';
import { ApplicationState } from '../../../models/applications/enum';
import {
  selectApplication,
  selectIsApplicationReadonly,
} from '../../../redux/selectors/enrollee/application';
import { useIsImpersonate } from '../../../utils/domain/impersonate';

const AchievementsPage: FC = () => {
  const { applicationId } = useParams();

  const isImpersonate = useIsImpersonate();
  const isAdmin = useAppSelector(selectIsUserAdmin);
  const application = useAppSelector(selectApplication);

  const readOnly =
    (useAppSelector(selectIsApplicationReadonly) && !isImpersonate) ||
    (!isAdmin && application?.state === ApplicationState.ENROLLED);

  const { onNextPageNavigate } = useFillingStatementsRoutesContext();

  const {
    isFormVisible,
    fields,
    onSubmit,
    achievements,
    refetchAchievementsForm,
  } = useAchievementsPageForm(Number(applicationId));

  return (
    <div>
      <FillingStatementsForm
        onSubmit={e => {
          e.preventDefault();
          onNextPageNavigate();
        }}
        className="achievements"
      >
        <AchievementsForm
          needToFetchAchievements={false}
          achievements={achievements}
          refetchAchievementsForm={refetchAchievementsForm}
        />

        {isFormVisible && (
          <>
            <h4 className="achievements__title">Дополнительная информация</h4>
            <Input
              className="profile-form__field"
              placeholder="Количество публикаций"
              type="number"
              {...fields.publicationsAmount}
              disabled={readOnly}
            />

            <Input
              className="profile-form__field"
              placeholder="Количество изобретений"
              type="number"
              {...fields.inventionsAmount}
              disabled={readOnly}
            />

            <Button
              type="button"
              className="achievements__button"
              onClick={onSubmit}
              disabled={readOnly}
            >
              Добавить
            </Button>
          </>
        )}
      </FillingStatementsForm>
    </div>
  );
};

export default AchievementsPage;
